import * as React from 'react';
import { FileFieldSchema } from '@cak-legacy/generation-core';
import { useDataContext, getObjectValueFromObject } from '@cak-legacy/generation-overview-core';
import { withRenderFieldHoc } from '../Hoc/withRenderFieldHoc';
import { withHideOnFieldHoc } from '../Hoc/withHideOnFieldHoc';

interface FileFieldProps {
  field: FileFieldSchema;
  name: string;
}

interface FileWrap {
  name: string;
}

export const FileField = withHideOnFieldHoc(
  withRenderFieldHoc((props: FileFieldProps): JSX.Element => {
    const persoonContext = useDataContext();
    const value = getObjectValueFromObject(persoonContext, props.name);

    if (props.field.ui?.readOverview?.isFilesOverview === true) {
      const files = Array.from(value ?? []);
      if (files.length === 0) {
        return <div className="read-item__file">-</div>;
      }
      return (
        <div role="list">
          {files.map((file: FileWrap, index) => {
            return (
              <div key={index} className="read-item__file" role="listitem">
                {file.name}
              </div>
            );
          })}
        </div>
      );
    }

    return <></>;
  })
);
